import { GetAnyExamsPayload } from "../hooks/exam-or-exercise/use-any-exams";

export const queryKeys = {
  schools: {
    all: ({ text, levelId }: { text?: string; levelId?: number }) =>
      ["schools", text, levelId] as const,
    targetSchoolGroups: () => ["schools", "target-school-groups"] as const,
  },
  auth: {
    all: () => ["auth"] as const,
    user: () => ["auth", "user"] as const,
    status: () => ["auth", "status"] as const,
  },
  users: {
    usernames: (searchText: string) => ["usernames", searchText] as const,
  },
  exams: {
    landingPage: (search?: string) =>
      ["exams", "landing-page", search] as const,
    maxAndMinYears: () => ["exams", "max-min-years"] as const,
    all: () => ["exams"] as const,
    search: (payload: GetAnyExamsPayload) => ["exams", payload] as const,
    detail: (slug: string) => ["exams", slug] as const,
    progress: (slug: string, userId: string) =>
      ["exams", slug, "progress", userId] as const,
    hasSolutionsFile: (examOrExerciseId: number) =>
      ["exams", "has-solutions-file", examOrExerciseId] as const,
    userExams: () => ["exams", "user-exams"] as const,
  },
  contests: {
    all: (mustHaveExams?: boolean, levelId?: number) =>
      ["contests", mustHaveExams, levelId] as const,
  },
  levels: {
    all: (
      mustHaveExams?: boolean,
      text?: string,
      withOther?: boolean,
      levelGroupId?: number
    ) => ["levels", mustHaveExams, text, withOther, levelGroupId] as const,
    groups: (withOther?: boolean) => ["levels", "groups", withOther] as const,
  },
  subjects: {
    all: () => ["subjects"] as const,
  },
  studentExamProgress: {
    section: (sectionId: number) =>
      ["student-exam-progress", "section", sectionId] as const,
    submissionResult: (submissionId: number) =>
      ["student-exam-progress", "submission-result", submissionId] as const,
  },
  sections: {
    section: (sectionId: number) => ["sections", "section", sectionId] as const,
  },
  studentGroups: {
    all: () => ["student-groups"] as const,
    myGroups: () => ["student-groups", "my-groups"] as const,
    sameSchoolStudents: () =>
      ["student-groups", "same-school-students"] as const,
    group: (id: number) => ["student-groups", "group", id] as const,
  },
  examSharings: {
    all: () => ["exam-sharings"] as const,
    sharedToMe: () => ["exam-sharings", "shared-to-me"] as const,
    studentsToWhichExamWasSharedSectionAnswers: (sectionId: number) =>
      [
        "exam-sharings",
        "students-to-which-exam-was-shared-section-answers",
        sectionId,
      ] as const,
  },
  admin: {
    all: () => ["admin"] as const,
    appUsers: (search: string) => ["admin", "app-users", search] as const,
  },
  userConversations: {
    all: () => ["user-conversations"] as const,
    conversation: (conversationId: string) =>
      ["user-conversations", "conversation", conversationId] as const,
  },
  cart: {
    userCart: () => ["cart", "user-cart"] as const,
  },
  aiInterviewTemplates: {
    all: () => ["ai-interview-templates"] as const,
  },
  userOrders: {
    order: (reference?: string) => ["user-orders", "order", reference] as const,
    all: () => ["user-orders"] as const,
  },
  aiInterviews: {
    all: () => ["ai-interviews"] as const,
    myAiInterviews: (status?: string) =>
      ["ai-interviews", "my-ai-interviews", status] as const,
    aiInterview: (aiInterviewId: number) =>
      ["ai-interviews", "ai-interview", aiInterviewId] as const,
    adminAiInterviews: (payload: unknown) =>
      ["ai-interviews", "admin-ai-interviews", payload] as const,
    templates: () => ["ai-interviews", "templates"] as const,
  },
} as const;
